import { Component, Input } from '@angular/core';

@Component({
  selector: 'eye-green-svg',
  templateUrl: './eye-green-svg.component.html',
  styleUrls: ['./../../svg.scss']
})
export class EyeGreenSvgComponent {
  constructor() { }
}
